import React, { Component } from 'react';
import Alert from 'sweetalert-react';
import * as Http from '../../../http'
import * as Business from '../../../utils/business'
import Loading from '../../../components/Loading'
import ReportChild from './ReportChild'
import { ProgressBar, MenuItem, DropdownButton, FormGroup, FormControl, InputGroup, Button } from 'react-bootstrap';

const dicSearchOptions = {
  report_date: 'Report Date',
  company: 'Company',
  report_name: 'Report Name',
  upload_time: 'Upload Time',
}

class ReportTable extends Component {
  state = {
    searchOption: 'report_date',
    searchValue: '',
    items: [],
    loading: true
  }

  batchWillDelete = null;

  componentDidMount() {
    this.getListFile()
  }

  getListFile = () => {
    Http.getListBatch(Business.COMPONENT.CAPITAL_PLANING, null)
      .then(data => {
        if (data && data.Success) {
          let listData = []
          for (let index = 0; index < data.Data.length; index++) {
            const element = data.Data[index];
            if (!element) continue;
            element.timestamp = new Date(element.upload_time).getTime()
            listData.push(element);
          }
          listData = listData.sort((a, b) => {
            return b.timestamp - a.timestamp;
          })
          this.setState({
            items: listData,
            loading: false
          })
        }
      })
  }

  deleteListItems = () => {
    Http.deleteBatch(Business.COMPONENT.CAPITAL_PLANING, this.batchWillDelete)
      .then(res => {
        if (res.Success) {
          this.getListFile()
        }
      })
    this.batchWillDelete = null
  }

  onDelete = reportName => {
    this.batchWillDelete = reportName;
    this.setState({
      showDeleteAlert: true
    })
  }

  search = () => {
    const objSearch = {
      report_date: this.state.searchOption === 'report_date' ? this.state.searchValue : null,
      company: this.state.searchOption === 'company' ? this.state.searchValue : null,
      report_name: this.state.searchOption === 'report_name' ? this.state.searchValue : null,
      upload_time: this.state.searchOption === 'upload_time' ? this.state.searchValue : null,
    }

    Http.getListBatch(Business.COMPONENT.CAPITAL_PLANING, objSearch)
      .then(data => {
        if (data && data.Success) {
          let listData = []
          for (let index = 0; index < data.Data.length; index++) {
            const element = data.Data[index];
            if (!element) continue;
            element.timestamp = new Date(element.upload_time).getTime()
            listData.push(element);
          }
          listData = listData.sort((a, b) => {
            return b.timestamp - a.timestamp;
          })
          this.setState({
            items: listData,
            loading: false
          })
        }
      })
  }


  render() {
    if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>

    return Business.isHasRole([Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_VIEW_REPORT]) && (
      <div className="card">
        <div className="header" style={{ marginBottom: '10px' }}>
          <h4 className="title">Capital list</h4>
        </div>
        <div className="content table-responsive table-full-width" style={{minHeight: '250px'}}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <div style={{ display: 'inline' }}>
              <DropdownButton title={dicSearchOptions[this.state.searchOption]} bsSize="small" id={`dropdown-size-${1}`}>
                <MenuItem onSelect={(eventKey, event) => { this.setState({ searchOption: eventKey }); }} eventKey={`report_date`}>{'Report Date'}</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.setState({ searchOption: eventKey }); }} eventKey={`report_name`}>{'Report Name'}</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.setState({ searchOption: eventKey }); }} eventKey={`company`}>{'Company'}</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.setState({ searchOption: eventKey }); }} eventKey={`upload_time`}>{'Upload Time'}</MenuItem>
              </DropdownButton>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input type='text' style={{ height: '30px' }} className="form-control" id="search_value"
                placeholder={(this.state.searchOption === 'report_date' || this.state.searchOption === 'upload_time') ? 'dd/mm/yyyy' : (this.state.searchOption === 'company' ? 'HDBANK or HDCONSOL' : '')}
                onChange={event => {
                  this.setState({ searchValue: event.target.value })
                }} />
              <button type="button" disabled={this.state.progressValue > 0} className="btn btn-primary"
                style={{
                  backgroundColor: '#FFE600',
                  borderColor: '#7F7E82',
                  borderRadius: '3px',
                  fontWeight: 600,
                  marginLeft: "auto",
                  float: 'left',
                  height: '30px',
                  fontSize: '10px'
                }}
                onClick={() => this.search()}>Search
              </button>
            </div>
          </div>
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Report Date</th>
                <th>Company</th>
                <th>Report name</th>
                <th>Capital Scenario</th>
                <th>Uploader</th>
                <th>Upload time</th>
              </tr>
            </thead>
            <tbody>
              {this.state.items.map(item => (
                <tr key={item.file_name}>
                  <td>{Business.convertToDate(item.report_date)}</td>
                  <td>{item.company}</td>
                  <td><ReportChild report={item} /></td>
                  <td>{item.capital_scenario}</td>
                  <td>{item.uploader}</td>
                  <td>{Business.convertToFullDate(item.upload_time)}</td>
                  <td className="text-right">
                    {
                      Business.isHasRole([Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_DELETE_REPORT])
                        ? (
                          <a rel="tooltip"
                            aria-disabled='true'
                            className="btn btn-info btn-simple btn-xs"
                            data-original-title="View Profile"
                            onClick={() => this.onDelete(item.file_name)}>
                            <i style={{ fontSize: 23, color: "red" }} className="pe-7s-trash"></i>
                          </a>
                        )
                        : (<div></div>)
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Alert
          title="Are you sure?"
          show={this.state.showDeleteAlert}
          text="You will not be able to recover this report!"
          showCancelButton
          onConfirm={() => {
            this.setState({ showDeleteAlert: false })
            this.deleteListItems()
          }}
          onCancel={() => {
            this.setState({ showDeleteAlert: false })
            this.batchWillDelete = null
          }} />
      </div>
    )
  }
}

export default ReportTable;



// WEBPACK FOOTER //
// ./src/pages/CapitalPlanning/Report/ReportTable.js